import api from './api';
import type { PlatformSettings, PlatformSettingsInput, PlatformWebhookStatus } from '../types';

/** Operator: Plattform-Einstellungen (`/api/platform/settings`). */
export const platformSettingsService = {
    async get(): Promise<PlatformSettings> {
        const { data } = await api.get('/platform/settings');
        return data;
    },
    async update(input: PlatformSettingsInput): Promise<PlatformSettings> {
        const { data } = await api.put('/platform/settings', input);
        return data;
    },
    async webhookStatus(): Promise<PlatformWebhookStatus> {
        const { data } = await api.get('/platform/settings/paypal-webhook');
        return data;
    },
    async registerWebhook(): Promise<{ webhookId: string; created: boolean; missingEvents: string[]; url: string }> {
        const { data } = await api.post('/platform/settings/paypal-webhook');
        return data;
    },
};

/** Feldfehler aus einer 422-Antwort (`errors: { 'issuer.iban': '…' }`). */
export const fieldErrors = (err: any): Record<string, string> => err?.response?.data?.errors ?? {};

export default platformSettingsService;
